const VIEWPORT_MARGIN = 8;
const ANCHOR_OVERLAP = 3;

export interface MenuPosition {
  readonly left: number;
  readonly placement: 'down' | 'up';
  readonly top: number;
}

interface ViewportSize {
  readonly height: number;
  readonly width: number;
}

export function anchoredMenuPosition(
  anchor: Pick<DOMRect, 'bottom' | 'left' | 'right' | 'top'>,
  menu: Pick<DOMRect, 'height' | 'width'>,
  viewport: ViewportSize,
): MenuPosition {
  const spaceBelow = viewport.height - anchor.bottom - VIEWPORT_MARGIN;
  const spaceAbove = anchor.top - VIEWPORT_MARGIN;
  const placement = spaceBelow < menu.height && spaceAbove > spaceBelow ? 'up' : 'down';
  const desiredTop =
    placement === 'up' ? anchor.top - menu.height + ANCHOR_OVERLAP : anchor.bottom - ANCHOR_OVERLAP;
  const top = Math.min(
    Math.max(VIEWPORT_MARGIN, desiredTop),
    Math.max(VIEWPORT_MARGIN, viewport.height - menu.height - VIEWPORT_MARGIN),
  );
  const desiredLeft = anchor.right - menu.width;
  const left = Math.min(
    Math.max(VIEWPORT_MARGIN, desiredLeft),
    Math.max(VIEWPORT_MARGIN, viewport.width - menu.width - VIEWPORT_MARGIN),
  );
  return { left, placement, top };
}

export function clampedHorizontalPopoverOffset(
  anchor: Pick<DOMRect, 'left'>,
  popover: Pick<DOMRect, 'width'>,
  boundary: Pick<DOMRect, 'left' | 'right'>,
  inset = VIEWPORT_MARGIN,
): number {
  const minimumLeft = boundary.left + inset;
  const maximumLeft = Math.max(minimumLeft, boundary.right - inset - popover.width);
  const clampedLeft = Math.min(Math.max(anchor.left, minimumLeft), maximumLeft);
  return clampedLeft - anchor.left;
}
